<template>
  <div id="root">
    <dv-loading class="loading-style" v-show="loading">数据加载中...</dv-loading>
    <el-config-provider v-show="!loading" :locale="locale">
      <router-view></router-view>
    </el-config-provider>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'

const locale = ref(zhCn)

// vuex
const store = useStore()

const loading = computed(() => {
  return store.getters.loading
})
</script>

<style lang="scss">
#root {
  height: 100vh;
  width: 100%;
  min-height: 1000px;
  min-width: 1640px;
  overflow: hidden;
}
.loading-style{
  background-color: rgba(9, 46, 95, 1);
  zoom: 1.3;
}
</style>
